import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10a4125c")

_pushScopeId("data-v-10a4125c")
const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Image by ")
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "Alejandro Henao.", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Made with ")
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fab fa-vuejs" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("footer", null, [
    _createTextVNode(" © nomeacuerdo.co " + _toDisplayString(_ctx.year) + ". ", 1 /* TEXT */),
    _hoisted_1,
    _hoisted_2,
    _createVNode("a", {
      href: _ctx.links.jhonny,
      target: "_blank"
    }, [
      _hoisted_3
    ], 8, ["href"]),
    _hoisted_4,
    _createVNode("a", {
      href: _ctx.links.vue,
      target: "_blank",
      class: "vuejs"
    }, [
      _hoisted_5
    ], 8, ["href"])
  ]))
})